import { addMonths, parseFullDate } from "../../../helpers/date-util.js";
import { formatAsMonthAndYear } from "../../../helpers/date-formatting-util.js";
import Model from "../../../../models/Model.js";

const yearPeriodType = "Year";
const numberOfMonthsPerYear = 12;

/**
 * Represent a Capego SIE file as sent by ImportApi.
 *
 * @param {string} id -
 * @param {"Year"|"Month"} periodType - The kind of period of the SIE file
 * @param {Date} period - The date of the last transaction in the SIE file
 */
export default class SieFile extends Model {
	constructor({ id, periodType, period } = {}) {
		super(...arguments);

		this._id = id;
		this._periodType = periodType;
		this._period = period;
	}

	isForYear() {
		return this._periodType === yearPeriodType;
	}

	getId() {
		return this._id;
	}

	getPeriod() {
		return this._period;
	}

	compare(sieFile) {
		return this._period - sieFile.getPeriod();
	}

	toString() {
		return this.isForYear()
			? this._toYearString()
			: formatAsMonthAndYear(this._period);
	}

	_toYearString() {
		const endDate = this._period;
		const startDate = addMonths(endDate, -numberOfMonthsPerYear + 1);

		startDate.setDate(1);

		return `${formatAsMonthAndYear(startDate)} - ${formatAsMonthAndYear(
			endDate,
		)}`;
	}

	static transformMaterializationData(data) {
		super.transformMaterializationData(...arguments);

		data.period &&= parseFullDate(data.period);
	}
}
